export enum AdministrativeLevels {
  COUNTRY = 'COUNTRY',
  STATE = 'STATE',
  MUNICIPALITY = 'MUNICIPALITY',
  SCHOOL = 'SCHOOL',
}
